// Result-matched affiliate picks for the lime calculator.
//
// We deliberately delegate to the soil-test tool's reviewed pH-prescription map
// (lib/soil-test/product-picks.ts) rather than re-listing catalog keys here, so
// both tools recommend the SAME products for the same pH direction:
//   - raise pH (lime)  -> `ph-low-apply-lime`  (Espoma Lightning Lime + compost)
//   - lower pH (sulfur) -> `ph-high-apply-sulfur` (Mag-I-Cal for alkaline soil +
//                          chelated iron for the chlorosis high pH causes)
// The catalog (data/guide-product-recommendations.ts) stays the single source of
// truth for names/ASINs/prices/images; this file only picks the direction.
//
// Future: a dedicated dolomitic-lime SKU and a pH test-kit SKU could be added to
// the catalog (verify anchor text = live Amazon title via `paapi:lookup` first),
// then routed here off `result.preferredSource`.

import { getSoilTestProducts } from '@/lib/soil-test/product-picks'
import type { ProductRecommendationLink } from '@/lib/product-picks/types'
import type { AmendmentDirection } from './calculator'

/** Curated picks for the result's amendment direction. Empty when in range. */
export function getLimePicks(direction: AmendmentDirection): ProductRecommendationLink[] {
  if (direction === 'lime') return getSoilTestProducts('ph-low-apply-lime')
  if (direction === 'sulfur') return getSoilTestProducts('ph-high-apply-sulfur')
  return []
}
